import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, map } from 'rxjs';
import { AuthService } from './auth.service';

// Satıcı portalı (/seller/*) yalnız `kartexseller` realm rolü içindir (B-19 §3.6). adminGuard ile aynı
// desen: oturum asenkron geri yüklendiği için önce whenSessionReady, sonra rol kontrolü.
export const sellerGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    return from(auth.whenSessionReady()).pipe(map(() => (auth.isKartexSeller() ? true : router.createUrlTree(['/notfound']))));
};
